// GAVION commissions: Rapports → Commissions, the statement page and « Mes commissions ».
export const commissionsReportsFr = {
  title: "Commissions",
  description:
    "Les relevés de commissions par personne, l'aperçu des montants et l'historique par client.",
  statements: {
    title: "Relevés",
    person: "Personne",
    cutoff: "Jusqu'au",
    preview: "Aperçu",
    create: "Créer un relevé",
    created: "Relevé créé",
    empty: "Aucun relevé.",
    open: "Relevé du %{cutoff}",
    choose_person: "Choisissez une personne.",
    preview_empty: "Aucune commission ni prime jusqu'à cette date.",
    total: "Total : %{amount}",
    to_pay: "À payer pour cette période : %{amount}",
    to_settle:
      "À régler avec l'employé (jamais retenu, hors versement) : %{amount}",
  },
  table: {
    month: "Mois",
    client: "Client",
    person: "Personne",
    kind: "Type",
    mrr: "MRR perçu",
    subscription_month: "Mois d'abonnement",
    split: "Part",
    rate: "Taux",
    amount: "Montant",
    explanation: "Explication",
    caption_preview: "Aperçu du relevé (ce qui reste à payer)",
    caption_client: "Lignes de %{name}",
    record_split: "Enregistrer le partage",
    base_hidden: "Base masquée",
  },
  checks: {
    title: "À vérifier",
    won_without_subscription: "Opportunités gagnées sans abonnement",
    without_source:
      "Abonnements dont la source de la vente manque (aucune commission)",
    none: "Rien à vérifier.",
  },
  history: {
    title: "Historique par client",
    client: "Client",
    empty: "Aucun gain pour ce client.",
  },
  statement: {
    title: "Relevé de commissions — %{name}",
    cutoff: "Jusqu'au %{date}",
    paid_on: "Versé le %{date}",
    loading: "Chargement du relevé…",
    refresh: "Actualiser",
    refreshed: "Relevé actualisé",
    delete: "Supprimer le brouillon",
    confirm_delete: "Supprimer ce relevé brouillon ?",
    deleted: "Relevé supprimé",
    mark_paid: "Marquer versé",
    paid_on_label: "Date du versement",
    note: "Note",
    confirm_paid: "Confirmer le versement",
    paid: "Relevé versé : il ne changera plus.",
    export: "Exporter (CSV)",
    print: "Imprimer",
    fees: "Frais uniques (information, hors commission)",
    subtotal: "Sous-total : %{amount}",
    total: "Total du relevé (versé) : %{amount}",
    to_settle_title:
      "À régler avec l'employé (retenue seulement avec consentement écrit)",
    to_settle_help:
      "Un remboursement ou une correction après un mois versé n'est jamais retenu sur un versement. Réglez-le avec l'employé (consentement écrit pour une retenue, remboursement, ou abandon), puis marquez-le réglé.",
    to_settle_total: "À régler (hors total) : %{amount}",
    vacation_pay: "Indemnité de vacances %{pct} % (pour la paie) : %{amount}",
    vacation_pay_help:
      "Information pour la paie, non incluse dans le total (sur %{base} versés).",
    settle: "Marquer réglé",
    settle_note: "Comment c'est réglé (ex. retenue autorisée par écrit le …)",
    settle_confirm: "Confirmer",
    settle_done: "Marqué réglé",
    settled: "Réglé le %{date} · %{kind} · %{note}",
    settle_kind: "Comment",
    settlement_kinds: {
      retenue: "Retenue (consentement écrit)",
      rembourse: "Remboursé par l'employé",
      abandonne: "Abandonné",
      annule: "Annulé par une correction",
    },
    not_settled: "Pas encore réglé",
    cancelled_pending:
      "Annulé par une correction maintenant due : rien à régler (fermé au prochain versement). S'il a déjà été remboursé ou retenu, l'enregistrer : le prochain relevé le repaiera.",
    no_lines: "Aucune ligne.",
    base_hidden:
      "Sur les ventes où vous n'êtes ni Closer ni Responsable de compte, seul votre montant est affiché (pas le MRR du client, ni le partage, ni le taux).",
    pending_rep:
      "%{smart_count} ligne « À décider » attend une décision sur le partage (art. 4.5.6) : elle n'est pas sur ce relevé, ni versée ni perdue. |||| %{smart_count} lignes « À décider » attendent une décision sur le partage (art. 4.5.6) : elles ne sont pas sur ce relevé, ni versées ni perdues.",
    pending:
      "%{smart_count} ligne « À décider » : le contrat ne fixe pas ce partage (art. 4.5.6). Elle n'est pas sur ce relevé (ni versée ni perdue), qui peut être versé ; enregistrez le partage convenu sur l'opportunité et elle ira sur le prochain relevé. |||| %{smart_count} lignes « À décider » : le contrat ne fixe pas ce partage (art. 4.5.6). Elles ne sont pas sur ce relevé (ni versées ni perdues), qui peut être versé ; enregistrez le partage convenu sur l'opportunité et elles iront sur le prochain relevé.",
  },
  mine: {
    title: "Mes commissions",
    description: "Vos relevés de commissions, en lecture seule.",
    empty: "Aucun relevé pour le moment.",
    item: "Relevé du %{cutoff}",
  },
};
